import { useMutation } from '@apollo/client';
import { graphql } from '@client/graphql/types';

const MUTATION = graphql(`
  mutation deleteAllergy($companyId: ID!, $code: ID!) {
    deleteAllergy(companyId: $companyId, code: $code) {
      companyId
      code
      description
      timestamp
      title
    }
  }
`);

export default function useDeleteAllergy() {
  return useMutation(MUTATION, {
    refetchQueries: ['allergies'],
  });
}
